import "./Search.scss";
import clsx from "clsx";
import { useState } from "react";
import { Button } from "@/components";
import { SearchIcon } from "@/icons";

type SearchProps = {
  btnText: string;
  helperText: string;
  value: string;
  variant?: "outlined" | "basic";
  onChangeValue?: (value: string) => void;
  onSearch?: (value: string) => void;
  dimensionStrategy?: "fixed" | "auto";
};

export const Search = ({
  btnText,
  helperText,
  onChangeValue,
  value,
  variant = "basic",
  onSearch,
  dimensionStrategy = "fixed"
}: SearchProps) => {
  const [valueInput, setValueInput] = useState(value);
  return (
    <div
      className={clsx(
        "ui-search",
        "br-x4 bg-border-secondary w-full",
        variant,
        {
          "ui-search-auto": dimensionStrategy === "auto",
        },
      )}
    >
      {variant === "basic" ? (
        <>
          <input
            id="search"
            type="search"
            className={clsx(
              "ui-search-input",
              "bg-white fs-6 text-slate-20 br-x4 w-full pl-x24",
            )}
            placeholder={helperText}
            aria-label="Barra di ricerca"
            autoComplete="off"
            value={valueInput}
            onChange={(e) => {
              if (onChangeValue) {
                onChangeValue(e.target.value);
              }
              setValueInput(e.target.value);
            }}
          />

          <div className={clsx("ui-div-btn")}>
            <Button
              className={clsx(
                "ui-btn-search",
                "bg-primary text-white fs-7 fw-semibold br-x4",
              )}
              onClick={() => onSearch?.(valueInput)}
            >
              {btnText}
            </Button>
          </div>
        </>
      ) : (
        <>
          <div className="ui-search-icon">
            <SearchIcon width={20} height={20} />
          </div>
          <input
            id="search"
            type="search"
            className={clsx(
              "ui-search-input",
              "bg-white fs-6 text-slate-20 br-x4 w-full pl-x24",
            )}
            placeholder={helperText}
            aria-label="Barra di ricerca"
            autoComplete="off"
            value={valueInput}
            onChange={(e) => {
              if (onChangeValue) {
                onChangeValue(e.target.value);
              }
              setValueInput(e.target.value);
            }}
          />
        </>
      )}
    </div>
  );
};
